import { extendObservable } from 'mobx';
import DigestRealm from './DigestRealm';

const SESSION_PATH = 'instreamer/session';

class Session {
    constructor() {
        extendObservable(this, {
            loggedIn: false
        });
    }

    async rpc(method, params, { timeout } = {}) {
        if (!this.realm) {
            this.loggedIn = false;
            return;
        }

        const req = {
            jsonrpc: '2.0',
            id: 1,
            method,
            params
        };
        const res = await this.realm.fetch('/cgi/rest.cgi', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            timeout,
            body: JSON.stringify(req, null, 2)
        });
        const data = JSON.parse(res);
        return data.result;
    }

    /*
    sessionTimeout() {
        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
    }
    }
    */

    async login(username, password) {
        console.log('session login: start');
        this.loggedIn = false;
        this.realm = new DigestRealm({ username, password });

        this.user = username;

        try {
            await this.rpc('call', ['', 'barix_webui', 'status_get_all', {}]);
            sessionStorage.setItem(
                SESSION_PATH,
                JSON.stringify({ username, password })
            );
            this.loggedIn = true;
        } catch (err) {
            this.loggedIn = false;
        }

        console.log('session login end:' + this.loggedIn);
        return this.loggedIn;
    }

    async restore() {
        const session = sessionStorage.getItem(SESSION_PATH);
        if (session) {
            const { username, password } = JSON.parse(session);
            return this.login(username, password);
        }
        return false;
    }

    logout() {
        sessionStorage.removeItem(SESSION_PATH);
        this.realm = null;
        this.loggedIn = false;
    }

    async getJsonStream() {
        try {
            let jsonStream = [];
            const sessioninstreamericeGet = await this.rpc('call', [
                '',
                'instreamer4',
                'get',
                {}
            ]);

            console.log(sessioninstreamericeGet);

            if (sessioninstreamericeGet === 500) {
                return 500;
            } else {
                if (
                    sessioninstreamericeGet[1].connection &&
                    sessioninstreamericeGet[1].server &&
                    sessioninstreamericeGet[1].input
                ) {
                    let connectionsLoop = Object.keys(
                        sessioninstreamericeGet[1].connection
                    );
                    console.log(connectionsLoop);

                    for (let i = 0; i < connectionsLoop.length; i++) {
                        if (
                            this.getInputKeys(
                                sessioninstreamericeGet[1],
                                sessioninstreamericeGet[1].connection[
                                    connectionsLoop[i]
                                ].input
                            )
                        ) {
                            console.log("Exists a connection ", sessioninstreamericeGet[1].connection[connectionsLoop[i]].input);
                            let outputOptions = sessioninstreamericeGet[1].connection[
                                connectionsLoop[i]
                                ].output;

                            if (typeof outputOptions === "string"){
                                console.log("outputOptions is string: ", outputOptions);
                                for (let j = 0; j < connectionsLoop.length; j++) {
                                    if (
                                        this.getEncoderKeys(
                                            sessioninstreamericeGet[1],
                                            sessioninstreamericeGet[1]
                                                .connection[connectionsLoop[j]]
                                                .input
                                        ) &&
                                        sessioninstreamericeGet[1].connection[
                                            connectionsLoop[j]
                                            ].input ===
                                        sessioninstreamericeGet[1]
                                            .connection[connectionsLoop[i]]
                                            .output
                                    ) {
                                        console.log("current connection input", sessioninstreamericeGet[1].connection[
                                            connectionsLoop[j]
                                            ].input, "is equal to current connection output: ", sessioninstreamericeGet[1]
                                            .connection[connectionsLoop[i]]
                                            .output);

                                        let outputEncoderOptions = sessioninstreamericeGet[1]
                                            .connection[connectionsLoop[j]]
                                            .output;

                                        if (typeof outputEncoderOptions === "string") {

                                            let OneTableLine = [];

                                            OneTableLine.push(
                                                sessioninstreamericeGet[1]
                                                    .input[
                                                    sessioninstreamericeGet[1]
                                                        .connection[
                                                        connectionsLoop[i]
                                                        ].input
                                                    ]
                                            );

                                            OneTableLine.push(
                                                sessioninstreamericeGet[1]
                                                    .encoder[
                                                    sessioninstreamericeGet[1]
                                                        .connection[
                                                        connectionsLoop[i]
                                                        ].output
                                                    ]
                                            );

                                            OneTableLine.push(
                                                sessioninstreamericeGet[1]
                                                    .server[
                                                    sessioninstreamericeGet[1]
                                                        .connection[
                                                        connectionsLoop[j]
                                                        ].output
                                                    ]
                                            );

                                            OneTableLine.push(
                                                sessioninstreamericeGet[1]
                                                    .connection[
                                                    connectionsLoop[j]
                                                    ].output
                                            );

                                            jsonStream.push(OneTableLine);

                                        } else {
                                            let outputEncoderOptions = Object.keys(
                                                outputEncoderOptions
                                            );
                                            for (
                                                let m = 0;
                                                m < outputEncoderOptions.length;
                                                m++
                                            ) {
                                                let OneTableLine = [];

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .input[
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[i]
                                                            ].input
                                                        ]
                                                );

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .encoder[
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[i]
                                                            ].output
                                                        ]
                                                );

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .server[
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[j]
                                                            ].output[
                                                            outputEncoderOptions[m]
                                                            ]
                                                        ]
                                                );

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .connection[
                                                        connectionsLoop[j]
                                                        ].output[
                                                        outputEncoderOptions[m]
                                                        ]
                                                );

                                                jsonStream.push(OneTableLine);
                                            }
                                        }
                                    }
                                }
                            } else {
                                let outputOptions = Object.keys(
                                    sessioninstreamericeGet[1].connection[
                                        connectionsLoop[i]
                                        ].output
                                );
                                console.log("outputOptions is an array with len: ", outputOptions.length);
                                for (let k = 0; k < outputOptions.length; k++) {
                                    for (
                                        let j = 0;
                                        j < connectionsLoop.length;
                                        j++
                                    ) {
                                        if (
                                            this.getEncoderKeys(
                                                sessioninstreamericeGet[1],
                                                sessioninstreamericeGet[1]
                                                    .connection[connectionsLoop[j]]
                                                    .input
                                            ) &&
                                            sessioninstreamericeGet[1].connection[
                                                connectionsLoop[j]
                                                ].input ===
                                            sessioninstreamericeGet[1]
                                                .connection[connectionsLoop[i]]
                                                .output[outputOptions[k]]
                                        ) {
                                            console.log("current connection input", sessioninstreamericeGet[1].connection[
                                                connectionsLoop[j]
                                                ].input, "is equal to current connection output: ", sessioninstreamericeGet[1]
                                                .connection[connectionsLoop[i]]
                                                .output[outputOptions[k]]);

                                            let outputEncoderOptions = sessioninstreamericeGet[1]
                                                .connection[connectionsLoop[j]]
                                                .output;

                                            //console.log(outputEncoderOptions);

                                            if (typeof outputEncoderOptions === "string") {

                                                console.log("outputEncoderOptions is string: ", outputEncoderOptions);

                                                let OneTableLine = [];

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .input[
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[i]
                                                            ].input
                                                        ]
                                                );

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .encoder[
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[i]
                                                            ].output[outputOptions[k]]
                                                        ]
                                                );

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .server[
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[j]
                                                            ].output[
                                                            outputEncoderOptions
                                                            ]
                                                        ]
                                                );

                                                OneTableLine.push(
                                                    sessioninstreamericeGet[1]
                                                        .connection[
                                                        connectionsLoop[j]
                                                        ].output[
                                                        outputEncoderOptions
                                                        ]
                                                );

                                                jsonStream.push(OneTableLine);

                                            } else {
                                                let outputEncoderOptions = Object.keys(
                                                    sessioninstreamericeGet[1]
                                                        .connection[connectionsLoop[j]]
                                                        .output
                                                );
                                                console.log("outputEncoderOptions is an array with len: ", outputEncoderOptions.length)

                                                for (
                                                    let m = 0;
                                                    m < outputEncoderOptions.length;
                                                    m++
                                                ) {
                                                    let OneTableLine = [];

                                                    OneTableLine.push(
                                                        sessioninstreamericeGet[1]
                                                            .input[
                                                            sessioninstreamericeGet[1]
                                                                .connection[
                                                                connectionsLoop[i]
                                                                ].input
                                                            ]
                                                    );

                                                    OneTableLine.push(
                                                        sessioninstreamericeGet[1]
                                                            .encoder[
                                                            sessioninstreamericeGet[1]
                                                                .connection[
                                                                connectionsLoop[i]
                                                                ].output[outputOptions[k]]
                                                            ]
                                                    );

                                                    OneTableLine.push(
                                                        sessioninstreamericeGet[1]
                                                            .server[
                                                            sessioninstreamericeGet[1]
                                                                .connection[
                                                                connectionsLoop[j]
                                                                ].output[
                                                                outputEncoderOptions[m]
                                                                ]
                                                            ]
                                                    );

                                                    OneTableLine.push(
                                                        sessioninstreamericeGet[1]
                                                            .connection[
                                                            connectionsLoop[j]
                                                            ].output[
                                                            outputEncoderOptions[m]
                                                            ]
                                                    );

                                                    jsonStream.push(OneTableLine);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            console.log("No connection found ", sessioninstreamericeGet[1].connection[connectionsLoop[i]].input);
                        }
                    }
                }
                //console.log(jsonStream);
                return jsonStream;
            }
        } catch (err) {
            console.error('session-getJsonStream:' + err);
        }
    }

    getInputKeys(session_instreamerice, instreamerice_conn_input_name) {
        let connectionsLoop = Object.keys(session_instreamerice.input);

        for (let i = 0; i < connectionsLoop.length; i++) {
            if (connectionsLoop[i] === instreamerice_conn_input_name) {
                return true;
            }
        }

        return false;
    }

    getEncoderKeys(session_instreamerice, instreamerice_conn_encoder_name) {
        let connectionsLoop = Object.keys(session_instreamerice.encoder);

        for (let i = 0; i < connectionsLoop.length; i++) {
            if (connectionsLoop[i] === instreamerice_conn_encoder_name) {
                console.log("Exists an encoder ", instreamerice_conn_encoder_name);
                return true;
            }
        }
        console.log("No encoder found ", instreamerice_conn_encoder_name);
        return false;
    }
}

const session = new Session();
export default session;



// WEBPACK FOOTER //
// ./src/session.js